
// initSubscribeDrawer()

function initSubscribeDrawer() {
  const drawer = document.querySelector('.subscribe-drawer')
  const success = Boolean(drawer.querySelector('.success'))
  const closeBtn = drawer.querySelector('.close-btn')
  const cookieName = 'no-subscribe-drawer'
  const shouldShowInitially = getInitialShowState()

  window.getSubscribeCookie = () => getCookie(cookieName)
  window.clearSubscribeCookie = () => clearCookie(cookieName)
  window.subscribeDrawer = drawer

  if(!shouldShowInitially)
    return remove()

  closeBtn.onclick = onCloseClick
  stateQue.push(updateDrawer)
  setState({ shouldShowSubscribe: shouldShowInitially })
  success ? initSuccess() : initForm()


  function onCloseClick() {
    setState({ shouldShowSubscribe: false })
    setCookie(cookieName, 'true', 7)
    drawer.addEventListener('transitionend', remove)
  }

  function updateDrawer() {
    state.shouldShowSubscribe
      ? drawer.classList.add('open')
      : drawer.classList.remove('open')
  }

  function getInitialShowState() {
    const hasSeen = getCookie(cookieName) === 'true'
    return !hasSeen
  }

  function remove() {
    drawer.parentNode && drawer.parentNode.removeChild(drawer)
  }

  function initSuccess() {
    setCookie(cookieName, 'true', 7)
    // remove()
  }

  function initForm() {
    const form = drawer.querySelector('form')
    const input = drawer.querySelector('.email')
    const submit = drawer.querySelector('.submit')

    stateQue.push(update)
    setState({ subscribeHasError: false })
    setState({ subscribeEmail: '' })

    input.oninput = onChange
    input.onchange = onChange
    input.onkeypress = onKeyPress
    submit.onclick = onClick

    function onClick() {
      const isValid = validateEmail(state.subscribeEmail)
      isValid ? form.submit() : setState({ subscribeHasError: true })
    }

    function onKeyPress(e) {
      var keyPressed = event.keyCode || event.which;
      if (keyPressed === 13) {
        event.preventDefault()
        return false
      }
    }

    function onChange(e) {
      setState({ subscribeHasError: false })
      setState({ subscribeEmail: e.target.value })
    }

    function update() {
      state.subscribeHasError
        ? input.classList.add('error')
        : input.classList.remove('error')
    }

    function validateEmail(input) {
      const validEmailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return validEmailRegEx.test(input.toLowerCase());
    }
  }

  function setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }

  function clearCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}

